// src/Studio/timeline/fxRuntime.activity.ts
//
// Task T5 of the 2026-04-08 studio file-splits plan. Pure mechanical
// extraction from fxRuntime.ts — no behavior change.
//
// Owns:
//   - FX_DEBUG flag
//   - fxActivityByBlockId + fxRouteStatusByBlockId Maps (module state)
//   - logFxBlockActivityTransition + logFxRouteStatusTransition
//   - cleanupStaleActivityEntries (replaces inline cleanup loops in
//     computeFxRenderPackets)

import type { FxBlock } from "./fxTypes";
import type { FxRenderPacket } from "./fxRuntime";

export const FX_DEBUG =
  typeof localStorage !== "undefined" &&
  localStorage.getItem("vb_fx_debug") === "1";

export const fxActivityByBlockId = new Map<string, boolean>();
export const fxRouteStatusByBlockId = new Map<string, string>();

export function logFxBlockActivityTransition(
  block: FxBlock,
  playhead: number,
  active: boolean,
): void {
  const previous = fxActivityByBlockId.get(block.id);
  if (previous === active) return;
  fxActivityByBlockId.set(block.id, active);
  if (!FX_DEBUG) return;
  try {
    console.debug(
      `[FX Runtime] Block ${block.id} ${active ? "active" : "inactive"} start=${block.start.toFixed(3)} end=${block.end.toFixed(3)} playhead=${playhead.toFixed(3)}`,
    );
  } catch {}
}

export function logFxRouteStatusTransition(
  packet: Pick<FxRenderPacket, "fxBlockId" | "effectType">,
  playhead: number,
  status: string,
): void {
  const previous = fxRouteStatusByBlockId.get(packet.fxBlockId);
  if (previous === status) return;
  fxRouteStatusByBlockId.set(packet.fxBlockId, status);
  if (!FX_DEBUG) return;
  try {
    console.debug(
      `[FX Route] block=${packet.fxBlockId} effect=${packet.effectType} status=${status} playhead=${playhead.toFixed(3)}`,
    );
  } catch {}
}

/**
 * Remove stale entries from the two activity Maps for block IDs that are
 * no longer in the scene. Called once per frame from
 * computeFxRenderPackets after it builds the seenBlockIds set.
 */
export function cleanupStaleActivityEntries(
  seenBlockIds: ReadonlySet<string>,
): void {
  for (const blockId of fxActivityByBlockId.keys()) {
    if (!seenBlockIds.has(blockId)) {
      fxActivityByBlockId.delete(blockId);
    }
  }
  for (const blockId of fxRouteStatusByBlockId.keys()) {
    if (!seenBlockIds.has(blockId)) {
      fxRouteStatusByBlockId.delete(blockId);
    }
  }
}
